import React, { useState } from 'react'
import wanderingLogo from '../assets/images/IMG_8203.png'
import '../styles/Profile.css'
import { useUser } from '../context/user'
import { useAuth } from '../context/auth'
import PrivacyAndSecurity from './PrivacyAndSecurity'
import AdvancedSettings from './AdvancedSettings'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import i18n from '../i18n'
import LanguageSettings from './LanguageSettings'
import NewPrivateNotes from './NewPrivateNotes'
import LogoutModal from './Modal/LogoutModal'
import InstructionVideoModal from './Modal/InstructionVideoModal'
import InstructionVideoComponent from './InstructionVideoComponent'
import TermsAndConditionsContentModal from './Modal/TermsAndConditionsContentModal'

// const unselectedColor = '#7ec5c6'
const unselectedColor = 'var(--light-blue)'
const selectedColor = '#3c8794'
const selectedTextColor = '#ffffff'
const unselectedTextColor = '#153c4f'

export default function Profile(props) {
    const { user } = useUser()
    const { t } = useTranslation()
    const history = useHistory()
    const { logoutUser } = useAuth()
    const [profileOption, setProfileOption] = useState('settings')
    const [logoutModalOpen, setLogoutModalOpen] = useState(false)
    const [instructionVideoVisible, setInstructionVideoVisible] = useState(false)
    const [isTCVisible, setTCVisible] = useState(false)

    const closeModal = () => {
        setLogoutModalOpen(false)
    }

    const logout = () => {
        setLogoutModalOpen(false)
        logoutUser()
        history?.push('/')
    }

    const toggleInstructionVideo = () => {
        setInstructionVideoVisible(!instructionVideoVisible)
    }
    const closeTCModal = () => setTCVisible(false)

    return (
        <div id="profileId" className={`profile-container ${i18n.language === 'ar' ? 'ar-lang' : ''}`}>
            <div className="profile-left shadow-custom-soft">
                <div className="profile-left-wrapper">
                    {/* TODO */}
                    <img src={wanderingLogo} className="profile-logo" style={{ opacity: 0 }} alt="Be Amazing" height={160} />

                    <div className="profile-actions">
                        <h2>
                            {t('hi')}, {user.first_name}! {t('thisIsYourPrivateRoom')}
                        </h2>
                        <div className="profile-tabs-container">
                            {/* {i18n.language === 'en' && (
                                <div
                                    className="private-notes-tab"
                                    style={{ backgroundColor: profileOption === 'video' ? selectedColor : unselectedColor }}
                                    onClick={() => {
                                        setProfileOption('video')
                                    }}
                                >
                                    <span className="private-notes-title" style={{ color: profileOption === 'video' ? selectedTextColor : unselectedTextColor }}>
                                        {t('instructionVideos')}
                                    </span>
                                    <div
                                        className="profile-triangle"
                                        style={{
                                            zIndex: 1,
                                            visibility: profileOption === 'video' ? 'visible' : 'hidden',
                                            backgroundColor: profileOption === 'video' ? selectedColor : unselectedColor,
                                        }}
                                    ></div>
                                </div>
                            )} */}
                            <div
                                className="private-notes-tab"
                                style={{ backgroundColor: profileOption === 'notes' ? selectedColor : unselectedColor }}
                                onClick={() => {
                                    setProfileOption('notes')
                                }}
                            >
                                <span className="private-notes-title" style={{ color: profileOption === 'notes' ? selectedTextColor : unselectedTextColor }}>
                                    {t('privateNotes')}
                                </span>
                                <div
                                    className="profile-triangle"
                                    style={{
                                        zIndex: 1,
                                        visibility: profileOption === 'notes' ? 'visible' : 'hidden',
                                        backgroundColor: profileOption === 'notes' ? selectedColor : unselectedColor,
                                    }}
                                ></div>
                            </div>
                            <div
                                className="private-notes-tab"
                                style={{ backgroundColor: profileOption === 'settings' ? selectedColor : unselectedColor }}
                                onClick={() => {
                                    setProfileOption('settings')
                                }}
                            >
                                <span className="private-notes-title" style={{ color: profileOption === 'settings' ? selectedTextColor : unselectedTextColor }}>
                                    {t('settings')}
                                </span>
                                <div
                                    className="profile-triangle"
                                    style={{
                                        zIndex: 1,
                                        visibility: profileOption === 'settings' ? 'visible' : 'hidden',
                                        backgroundColor: profileOption === 'settings' ? selectedColor : unselectedColor,
                                    }}
                                ></div>
                            </div>
                        </div>
                        <div className="profile-policies-wrapper">
                            <span className="profile-policies" style={{ marginBottom: 5, cursor: 'pointer' }} onClick={() => setTCVisible(true)}>
                                {t('termsAndConditions')}
                            </span>
                        </div>
                        <div>
                            <button className="logout-btn" onClick={() => setLogoutModalOpen(true)}>
                                {t('logout')}
                            </button>
                        </div>
                        <div className="app-version">{t('appVersion')}5.1.2</div>
                    </div>
                </div>
            </div>
            <div className="profile-right ">
                {profileOption === 'settings' && (
                    <>
                        {/* <LanguageSettings /> */}
                        <AdvancedSettings />
                        <PrivacyAndSecurity />
                    </>
                )}
                {profileOption === 'notes' && <NewPrivateNotes />}
                {/* {profileOption === 'video' && <InstructionVideoComponent />} */}
            </div>
            <LogoutModal modalIsOpen={logoutModalOpen} closeModal={closeModal} logout={logout} />
            {/* <InstructionVideoModal isOpen={instructionVideoVisible} onRequestClose={toggleInstructionVideo} /> */}
            <TermsAndConditionsContentModal modalIsOpen={isTCVisible} closeModal={closeTCModal} />
        </div>
    )
}
